import { render, staticRenderFns } from "./QuoteLimitSettingDia.vue?vue&type=template&id=19ff1017&scoped=true"
import script from "./QuoteLimitSettingDia.vue?vue&type=script&lang=js"
export * from "./QuoteLimitSettingDia.vue?vue&type=script&lang=js"
import style0 from "./QuoteLimitSettingDia.vue?vue&type=style&index=0&id=19ff1017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ff1017",
  null
  
)

export default component.exports